"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BoxedButtonBase } from "./ButtonBase.js";
import { getButtonVariantProps } from "./createButtonVariant.js";
const GhostButton = forwardRef(function GhostButton2(props, ref) {
  return jsx(BoxedButtonBase, { ref, ...getButtonVariantProps("transparent", props) });
});
export {
  GhostButton
};
